import React,{useState, useEffect, useContext} from 'react';
import $ from 'jquery'; 

import {
    Row,
    Col,      
    Button,
    InputGroup,
    Form,
    Alert,
    FormControl
} from 'react-bootstrap';
import _ from 'lodash';
import axios from 'axios';

import {Uploader, RTEditor} from '../../components';
import Utils from './../../Utils';
import UserContext from '../../contexts/UserContext';

const defaultQuesStruct = (data) => {
    var def = {        
        question    : '',    
        description : '',
        type        : 0,
        answers     : ['','','',''],
        explanations: ['', '', '', ''],
        correct     : [0],
        countable   : true,
        feedback    : true,
    };
    return {...def,...data};
}

const QuestionForm = (props) => {

    const isEdit = () => {
        return _.get(props,'mode',0);
    };
    const {getMaxScormSize, getPkgSize, getAvailableSize} = useContext(UserContext);
    const [question,setQuestion] = useState(defaultQuesStruct(props.data));
    const [audio, setAudio] = useState(_.get(props,'data.audio', ''));
    const [size, setSize] = useState(_.get(props,'data.size', 0));
    const [errMsg,setErrMsg] = useState('');
    const audiosize_in_mb =  _.get(process.env,'REACT_APP_MAX_AUDIO_SIZE',1);
    const scormsize_in_mb = getMaxScormSize();//_.get(process.env,'REACT_APP_MAX_SCORM_SIZE',50);


    function setLabelForRadioCheckbox() {
        $('input[type=checkbox] ~ label').remove();
        $('input[type=radio] ~ label').remove();
        $('input[type=checkbox]').each(function() {
            var id = $(this).attr('id');
            $('<label for="'+id+'"></label>').insertAfter(this);
        })
        $('input[type=radio]').each(function() {
            var id = $(this).attr('id');
            $('<label for="'+id+'"></label>').insertAfter(this);
        })
    }
    
    useEffect(() => {
        setLabelForRadioCheckbox();
    }, [question.type]);

    const onUploadAudio = (attr,status) => {  
        if(status==='error_file_size'){
          setErrMsg(`You have uploaded ${(attr.meta.size/1024/1024).toFixed(1)} MB file, however, 
          the acceptable maximum file size is ${getAvailableSize(audiosize_in_mb)} MB. Try again with an acceptable sized file.`);
        }else{  
          let file_size = (status.size/1024/1024).toFixed(1);
          setSize(file_size);
          let tot_size = parseInt(file_size) + getPkgSize();
          if(tot_size > scormsize_in_mb){
            setErrMsg(`Total SVASU size allowed is ${scormsize_in_mb} MB,You have used ${getPkgSize()} MB.`);
            return;
          }else{
            setErrMsg('');
            var tmp = attr;
            setAudio(tmp);
          }
        }
      }

    const finalizeQuestion = () => {
        if(question.correct[0] === "" || question.correct[0] === undefined){
            alert("Please select the correct answer option.");
            return;
        }
        question['audio'] = audio;
        question['size'] = size;
        props.onFinalize(question,'Question',isEdit());
    }

    const removeAudio = () => {    
        if(window.confirm('This will remove the audio file.. continue?')){
            axios.delete(Utils.apiUrl('delfile?file=' + audio), Utils.apiHeaders());
            setAudio('');
            setSize(0);
        }
      }

    const getCorrectValue = (frm) => {
        const tp = parseInt(frm.type.value);
        if(tp===0){
            return [frm.correct.value];
        }else{
            var tmp = [];
            for(var opts = 0; _.get(frm,`correct_${opts}`,false)!==false; opts++){
                if(frm[`correct_${opts}`].checked){
                    tmp.push(parseInt(frm[`correct_${opts}`].value));
                }
            }
            return tmp;
        }
    }

    const onQuestionSubmit = (e) => {        
        e.preventDefault();
        onQuestionSave(e.currentTarget);
    }

    const onQuestionChange = (e) => {        
        onQuestionSave(e.currentTarget.form);
    } 

    const onFeedbackChange = (e) => {        
        onQuestionSave(e.currentTarget.form);
    }

    const setDesc = (questionDesc) => {        
        if(typeof(questionDesc) === "object"){
            let tmp = {...question};
            tmp.explanations[questionDesc.id]= questionDesc.expl;
            setQuestion(tmp)            
        }else{
            setQuestion({...question,description: questionDesc});
        }        
    }

    const onQuestionSave = (frm) => {
        var ques = {            
            type        : parseInt(frm.type.value),
            question    :  frm.question.value,
            description : frm.description.value,
            answers     : [],
            explanations: [],
            correct     : getCorrectValue(frm),
            countable   : frm.countable.checked,
            feedback    : frm.feedback.checked 
        };

        for(var opts = 0; _.get(frm,`anstxt_${opts}`,false)!==false; opts++){
            ques['answers'].push(frm[`anstxt_${opts}`].value);
        }
            for(var explns = 0; question.explanations[explns]; explns++){
                ques['explanations'].push(question.explanations[explns]);
            }
        
        setQuestion(ques);
    }

    const setQuestionType = (e) => {
        setQuestion({...question,type: parseInt(e.currentTarget.value)});
    }

    const addMoreOption = (e) => {
        var tmp = {...question};
        tmp.answers.push('');
        tmp.explanations.push('');
        setQuestion(tmp);
        setTimeout(function() {
            setLabelForRadioCheckbox();
        }, 100)
    }

    const removeAnswer = (e) => {
        const aidx = parseInt(e.currentTarget.getAttribute('aid'));                
        var tmp = {...question};
        _.remove(tmp.answers,(a,anidx) => anidx===aidx);        
        _.remove(tmp.explanations,(a,anidx) => anidx===aidx);   
        setQuestion(tmp);
    }

    const renderQuestionForm = (q) => {
        return <Form onSubmit={onQuestionSubmit} className="addQuestion">                 
                <InputGroup className="mb-3">
                    <InputGroup.Prepend><InputGroup.Text className="quesLabel">Question Title: </InputGroup.Text></InputGroup.Prepend>
                    <FormControl
                        onChange={onQuestionChange}
                        name="question"
                        placeholder="* Enter your question title"
                        defaultValue={q.question}
                        aria-label="Question"
                    />
                </InputGroup>
                <InputGroup className="mb-3">
                    <InputGroup.Prepend><InputGroup.Text className="quesLabel">Question: </InputGroup.Text>
                    </InputGroup.Prepend>
                    <span 
                    className="w-100 text-left">
                    <RTEditor 
                    as="textarea"
                    rows={6}
                    name="description" 
                    srcType="video"
                    setDesc={setDesc}
                    value={q.description}
                    aria-label="Question"
                    placeholder="Enter your question" /></span>
                </InputGroup>
            
                <InputGroup className="mb-3 type">
                    <InputGroup.Prepend><InputGroup.Text className="quesLabel">Type: </InputGroup.Text></InputGroup.Prepend>
                    <FormControl as="select" onChange={setQuestionType} defaultValue={q.type} name="type">
                        {Utils.questionType.map((qt,qtidx) => <option key={qtidx} value={qtidx}>{qt}</option>)}                    
                    </FormControl>
                </InputGroup>

                <Alert variant="info">Please select the right answer for SVASU to track the correct answer.</Alert>

                <Row>
                    <Col sm={2}>
                        <span className="correctness mt-3" >Please Select : </span>
                    </Col>
                    <Col sm={5}>
                        <InputGroup className="mb-3 correctness">
                            <InputGroup.Prepend>                    
                                <InputGroup.Checkbox id="countable" name="countable" onClick={onQuestionChange} defaultChecked={q.countable} />                    
                            </InputGroup.Prepend>
                            <FormControl readOnly placeholder="Correctness of this question will impact your score." />
                        </InputGroup>
                    </Col>
                    <Col sm={5}>
                        <InputGroup className="mb-3 correctness">
                            <InputGroup.Prepend>                    
                                <InputGroup.Checkbox id="feedback" name="feedback" onClick={onFeedbackChange} defaultChecked={q.feedback} />                    
                            </InputGroup.Prepend>
                            <FormControl readOnly placeholder="Display feedback after submitting question." />
                        </InputGroup>
                    </Col>
                </Row>
                <div className="queans">
                    {q.answers.map((a,aidx) => <InputGroup key={aidx} id={aidx} className="mb-3">
                    <InputGroup.Prepend>
                        {q.type===0 &&<>                         
                            <InputGroup.Radio id={`radio_${aidx}`} name={`correct`} onClick={onQuestionChange} 
                                    defaultChecked={q.correct.includes(String(aidx))} value={aidx} 
                            />
                            
                        </>
                        }
                        {q.type===1 && <>                         
                                <InputGroup.Checkbox id={`checkbox_${aidx}`} name={`correct_${aidx}`} onClick={onQuestionChange} defaultChecked={q.correct.includes(aidx)} value={aidx} />                        
                            </>
                        }                    
                    </InputGroup.Prepend>
                    
                    <FormControl name={`anstxt_${aidx}`} onChange={onQuestionChange} placeholder={`Type Option ${aidx+1} here.`} value={q.answers[aidx]} />
                        {aidx > 1 && <InputGroup.Append>
                            <Button size="sm" variant="danger" aid={aidx} title="Remove Option" onClick={removeAnswer}>X</Button>
                        </InputGroup.Append>}                
                        <span className="w-100 text-left">  <br />
                        <InputGroup.Prepend><InputGroup.Text className="quesLabel">Explanation: </InputGroup.Text>
                        </InputGroup.Prepend>
                        <RTEditor 
                            as="textarea"
                            rows={6}
                            name={`expln_${aidx}`} 
                            // srcType="Video"
                            setDesc={setDesc}
                            idx={aidx}
                            value={`${q.explanations[aidx]}`}
                            aria-label="Question"
                            placeholder={`Enter Explanation for Option ${aidx+1}`}
                        />                        
                    </span>       
                </InputGroup>)}
            </div>

            <Row className="addMoreOpt">
                <Col sm={12} className="text-center">
                {q.answers.length < 6 && <Button size="sm" variant="success" title="Add Option" onClick={addMoreOption}>+</Button>}
                </Col>
            </Row>        
        </Form>;
    }

    return <>  
    <div className="popcotentpad">
        <Row className="m-2 text-center">
            <Col sm={12}>{renderQuestionForm(question)}</Col>
        </Row>
        <Row className="mx-2">
            <Col sm={1} className="text-left"><i className="icon aud"></i></Col>
            {audio==='' && <>
                <Col title="Select File" sm={11} className="text-left" style={{minHeight: '150px', maxHeight: '150px', overflow: 'hidden'}}>
                    <Uploader accept="audio/*" 
                        instructions={`Click the icon or drag and drop the file to upload your audio file. Max file size allowed is ${getAvailableSize(audiosize_in_mb)} MB.  Supported file formats are .mp3 and .ogg only.`}
                        uploadUrl={Utils.apiUrl('saveupload')} onUpload={onUploadAudio} />
                </Col>     
            </>}    
            {audio!=='' && <>
                <Col sm={12} className="text-center">
                    <audio controls>      
                        <source src={Utils.apiUrl(`file?f=${audio}`)} type="audio/mpeg" />
                        Your browser does not support the audio element.
                    </audio>
                    <span className="fa fa-2x fa-trash text-primary clickable ml-3 mt-2 position-absolute" title="Remove Audio" onClick={removeAudio} />
                </Col>
            </>}
        </Row>

        <Row className="m-2 text-center mb80">
            <Col sm={12}>
                <img src={`${process.env.PUBLIC_URL}/images/upload-quizz_button.png`} className="clickable mx-2" alt="finalize Quiz" onClick={finalizeQuestion} />                
            </Col>
        </Row>
        </div>
    </>;
}

export default QuestionForm;